import React, {Component} from 'react';
import _ from 'lodash';
import moment from 'moment';
import RadioToggle from 'components/RadioToggle';
import DateSelector from 'components/DateSelector';

class PatientForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            invalidFields: [],
            isPhotoSelected: false,
        };

        this.formatAndValidateDate = this.formatAndValidateDate.bind(this);
        this.handleFileSelect = this.handleFileSelect.bind(this);
        this.clearPhotoInput = this.clearPhotoInput.bind(this);

        this.photoFileInput = React.createRef();
    }

    formatAndValidateDate(event) {
        const date = moment(event.target.value);

        if (!date.isValid()) {
            this.setState({
                invalidFields: [...this.state.invalidFields, event.target.name],
            });
        } else {
            this.setState({
                invalidFields: _.without(this.state.invalidFields, event.target.name),
            });
        }

        const eventClone = _.cloneDeep(event);
        eventClone.target.value = date.format('l');

        this.props.onChange(eventClone);
        return eventClone;
    }

    clearPhotoInput() {
        this.setState({
            isPhotoSelected: false,
            photo: {},
        });

        this.props.onChange({
            target: {
                name: 'photo',
                value: null,
            }
        });
        this.props.onChange({
            target: {
                name: 'photoUrl',
                value: null,
            }
        });
    }

    handleFileSelect(event) {
        const file = this.photoFileInput.current.files[0];

        if (file && (file.size > 5e6 || !['image/jpeg', 'image/png', 'application/pdf'].includes(file.type))) {
            alert('Please select a .jpg, .png. .pdf file smaller than 5MB.');
            this.clearPhotoInput();
        } else {
            const reader = new FileReader();

            reader.onload = (event2) => {
                const photo = {
                    mimetype: file.type,
                    filename: file.name,
                    data: event2.target.result.replace(/^.*,/, ''),
                };

                this.setState({
                    isPhotoSelected: true,
                    photo
                });

                this.props.onChange({
                    target: {
                        name: 'photo',
                        value: photo,
                    }
                });
            };

            reader.readAsDataURL(file);
        }
    }

    render() {
        const hasInvalidFields = _.values(this.props.requiredFieldClasses).join().includes('invalid') || !_.isEmpty(this.state.invalidFields);
        const fieldClasses = _.clone(this.props.requiredFieldClasses);

        _.forEach(this.state.invalidFields, (field) => {
            fieldClasses[field] = _.get(fieldClasses, field, '').concat(' invalid');
        });

        const {patient, availableRooms} = this.props;

        return (
            <div className='form'>
                {hasInvalidFields &&
                <div className='alert alert-danger'>
                    Highlighted fields are invalid
                </div>
                }
                <div className='row'>
                    <div className='col-md-4 br'>
                        <div className={`form-group ${fieldClasses.photo || ''}`}>
                            <label htmlFor='photo'>Resident Photo</label>
                            {(this.state.isPhotoSelected || patient.photoUrl) ? (
                                <div className='photo-preview'>
                                    {patient.photoUrl ? (
                                        <img alt='resident' src={patient.photoUrl} />
                                    ) : (
                                        <img alt='resident' src={`data:${this.state.photo.mimetype};base64,${this.state.photo.data}`} />
                                    )}
                                    <button className='btn btn-info' onClick={this.clearPhotoInput}>Remove</button>
                                </div>
                            ) : (
                                <div className='custom-file'>
                                    <input type='file' className='custom-file-input' id='photo' ref={this.photoFileInput} onChange={this.handleFileSelect} />
                                    <label className='custom-file-label' htmlFor='photo'>Choose File...</label>
                                </div>
                            )}
                        </div>
                        <div className={`form-group ${fieldClasses.room || ''}`}>
                            <label htmlFor='bed'>Room / Bed</label>
                            <select className='custom-select' name='bed' value={patient.bed}
                                onChange={this.props.onChange} onBlur={this.props.onValidateRequired} >
                                <option key={0} value={null}>Unassigned</option>
                                {availableRooms.map((bed) => (
                                    <option key={bed.id} value={bed.id}>{bed.room_name} {bed.bed_name ? ' / ' + bed.bed_name : ''}</option>
                                ))}
                            </select>
                        </div>
                        <div className={`form-group ${fieldClasses.atRisk || ''}`}>
                            <div className="col-md-6">
                                Resident at Risk
                                <RadioToggle name='atRisk' id='atRisk' value={patient.atRisk || false} onClick={this.props.onChangeAtRisk} />
                            </div>
                            {/*<div className='form-check'>
                                <input className='form-check-input' type='checkbox' name='atRisk' id='atRisk' checked={patient.atRisk || false} onChange={this.props.onChange} />
                                <label className='form-check-label' htmlFor='atRisk'>Resident at Risk</label>
                                </div>*/}
                        </div>
                    </div>
                    <div className='col-md-8'>
                        <div className='row'>
                            <div className={`col-md-6 form-group ${fieldClasses.firstName || ''}`}>
                                <label htmlFor='firstName'>First Name</label>
                                <input type='text' name='firstName' className='form-control'
                                    onChange={this.props.onChange} onBlur={this.props.onValidateRequired}
                                    value={patient.firstName} />
                            </div>

                            <div className={`col-md-6 form-group ${fieldClasses.middleName || ''}`}>
                                <label htmlFor='middleName'>Middle Name</label>
                                <input type='text' name='middleName' className='form-control'
                                    onChange={this.props.onChange} onBlur={this.props.onValidateRequired}
                                    value={patient.middleName} />
                            </div>
                            <div className={`col-md-6 form-group ${fieldClasses.lastName || ''}`}>
                                <label htmlFor='lastName'>Last Name</label>
                                <input type='text' name='lastName' className='form-control'
                                    onChange={this.props.onChange} onBlur={this.props.onValidateRequired}
                                    value={patient.lastName} />
                            </div>
                            <div className={`col-md-6 form-group ${fieldClasses.dob || ''}`}>
                                <label htmlFor='dob'>Date of Birth</label>
                                <DateSelector name='dob' value={moment(patient.dob)} onChange={this.props.onChange} />
                            </div>
                            <div className={`col-md-6 form-group`}>
                                <label htmlFor='chronic-condition'>Chronic Condition</label>
                                <select className={'custom-select'} name='chronic_condition' value={patient.chronic_condition} onChange={this.props.onChange}>
                                    <option value={''}>Select Condition</option>
                                    <option value={"CHF"}>Congestive Heart Failure</option>
                                    <option value={"COPD"}>Chronic Obstructive Pulmonary Disease</option>
                                    <option value={"Diabetes"}>Diabetes</option>
                                    <option value={"Hypertension"}>Hypertension</option>
                                    <option value={"MCI"}>MCI</option>
                                    <option value={"Dementia"}>Dementia</option>
                                    <option value={"Alzheimers"}>Alzheimers</option>
                                    <option value={"Arthritis"}>Arthritis</option>
                                </select>
                            </div>
                            {false &&
                            <div className={`col-md-6 form-group ${fieldClasses.dob || ''}`}>
                                <label htmlFor='dob'>Date of Birth</label>
                                <input type='date' name='dob' className='form-control'
                                    onChange={this.props.onChange} onBlur={(event) => this.props.onValidateRequired(this.formatAndValidateDate(event))}
                                    value={patient.dob} />
                            </div>
                            }
                            <div className={`col-md-6 form-group ${fieldClasses.gender || ''}`}>
                                <label>Gender</label>
                                <div>
                                    <div className='form-check form-check-inline'>
                                        <input
                                            className='form-check-input'
                                            type='radio'
                                            id='genderMale'
                                            value='M'
                                            name='gender'
                                            checked={patient.gender === 'M'}
                                            onChange={this.props.onChange}
                                            onBlur={this.props.onValidateRequired}
                                        />
                                        <label className='form-check-label' htmlFor='genderMale'>Male</label>
                                    </div>

                                    <div className='form-check form-check-inline'>
                                        <input
                                            className='form-check-input'
                                            type='radio'
                                            id='genderFemale'
                                            value='F'
                                            name='gender'
                                            checked={patient.gender === 'F'}
                                            onChange={this.props.onChange}
                                            onBlur={this.props.onValidateRequired}
                                        />
                                        <label className='form-check-label' htmlFor='genderFemale'>Female</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PatientForm;
